import MetricsCardTitle from "@/pages/dashboard/components/MetricsCardTitle";
import SegmentScrollCo from "@/pages/dashboard/components/SegmentScrollCo";
import realtimeAnalysisFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeAnalysisFilterNew";
import realtimeCountryFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeCountryFilterNew";
import realtimeDownloadFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeDownloadFilterNew";
import realtimeNightingaleCountryFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeNightingaleCountryFilter";
import realtimeUserFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeUserFilterNew";
import RankListTabCo from "@/pages/dashboard/pages/overview/components/RankListTabCo";



import MetricCard from '@/pages/dashboard/components/MetricCardItem/MetricCard';
import MetricCardCo from "@/pages/dashboard/pages/realtime/realtimeUsers/component/MetricCardCo";
import realtimeUserService from "@/pages/dashboard/pages/realtime/realtimeUsers/component/realtimeUserService";
import DataDownloadTableCo from "@/pages/dashboard/pages/realtime/realtimeUsers/component/DataDownloadTableCo";
import RealtimeRentationContext from "@/pages/dashboard/pages/realtime/realtimeUsers/component/RealtimeRentationContext";
import MetricsCardContext from "@/pages/dashboard/pages/realtime/realtimeUsers/component/MetricsCardContext";
import ChangeAnalysisContext from "@/pages/dashboard/pages/realtime/realtimeUsers/component/ChangeAnalysisContext";
import TrendChartCo from "@/pages/dashboard/components/TrendChartCo";
import CountriesPlatformRegionTab from "@/pages/dashboard/components/CountriesPlatformRegionTab";
import RankListDropdownCo from "@/pages/dashboard/components/RankListDropdownCo";
import ScrollBodyCo from "@/pages/dashboard/pages/realtime/realtimeUsers/component/ScrollBodyCo";
import AnalysisTopChangeCard from "@/pages/dashboard/pages/realtime/realtimeUsers/component/AnalysisTopChangeCard";
import RealtimeRevenueContext from "@/pages/dashboard/pages/realtime/revenue/components/RealtimeRevenueContext";
import realtimeRevenueService from "@/pages/dashboard/pages/realtime/revenue/components/realtimeRevenueService";
import RealtimeRevenueFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeRevenueFilterNew";
import RealtimeSteamFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeSteamFilter";
import realtimeSteamService from "@/pages/dashboard/pages/realtime/steam/components/realtimeSteamService";
import RealtimeSteamContext from "@/pages/dashboard/pages/realtime/steam/components/RealtimeSteamContext";
import SteamSalesCard from "@/pages/dashboard/pages/realtime/steamSales/component/SteamSalesCard";
import CardContext from "@/pages/dashboard/pages/realtime/steamSales/component/CardContext";
import realtimeSteamSalesFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeSteamSalesFilter";
import realtimeSteamSalesCountryFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeSteamSalesCountryFilter";
import SteamSalesService from "@/pages/dashboard/pages/realtime/steamSales/component/SteamSalesService";
import RealtimeSteamCCUFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeSteamCCUFilter";
import RealtimeSteamCCUService from "@/pages/dashboard/pages/realtime/steamCCU/component/realtimeSteamCCUService";
import realtimeSalesFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeSalesFilter";
import realtimeSalesPlatformFilter from "@/pages/dashboard/filterPageComponents/realtime/realtimeSalesPlatformFilter";
import { SegmentScrollChildrenWrapper } from "@/pages/dashboard/components/SegmentScrollCo/components/SegmentScrollChildrenWrapper";
import RealtimeOverviewTrend from "@/pages/dashboard/pages/realtime/components/RealtimeOverviewTrend";
import RealtimeOverviewTrendContent from "@/pages/dashboard/pages/realtime/components/RealtimeOverviewTrendContent";
import MetricBarCard from "@/pages/dashboard/components/MetricBarCard";
import BottomCard from "@/pages/dashboard/components/BottomCard";
import ProgressBar from "@home/components/ProgressBar";

export default {
  // Realtime
  SegmentScrollCo,
  SegmentScrollChildrenWrapper,
  ScrollBodyCo,
  RankListDropdownCo,
  CountriesPlatformRegionTab,
  realtimeUserFilter,
  realtimeCountryFilter,
  realtimeAnalysisFilter,
  realtimeDownloadFilter,
  realtimeNightingaleCountryFilter,
  realtimeUserService,
  DataDownloadTableCo,
  MetricsCardTitle,
  RankListTabCo,
  RealtimeRentationContext,
  MetricsCardContext,
  MetricCard,
  MetricCardCo,
  ChangeAnalysisContext,
  TrendChartCo,
  AnalysisTopChangeCard,
  RealtimeRevenueFilter,
  RealtimeRevenueContext,
  realtimeRevenueService,
  RealtimeSteamFilter,
  realtimeSteamService,
  RealtimeSteamContext,
  SteamSalesCard,
  CardContext,
  realtimeSteamSalesFilter,
  realtimeSteamSalesCountryFilter,
  SteamSalesService,
  RealtimeSteamCCUFilter,
  RealtimeSteamCCUService,
  realtimeSalesFilter,
  realtimeSalesPlatformFilter,
  RealtimeOverviewTrend,
  RealtimeOverviewTrendContent,
  MetricBarCard,
  BottomCard,
  ProgressBar,
};